// extracted by css-extract-rspack-plugin
export default {"header":"_z1I8"};